export const environment = {
  name: 'pftest',
  production: false,
  SIGN_UP_URL: 'https://discover.risepeople.com/xero-and-rise/',
  JE_API_URL: 'https://je-gateway-test.risepeople.com',
  APP_NAME: 'je-utility-fe'
};
